import { AmplifyPost } from "@sunrun/sales-experience-shared/amplify-api-wrapper";
import { logger } from "providers/logger";

const sendCustomerAppDownloadText = async (jwt: string, prospectId: string) => {
  return await AmplifyPost(
    "Send Customer App Download Text",
    "OfferExpApi",
    `/prospect/${prospectId}/sendCustomerDownloadText`,
    {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    },
    logger
  );
};

export { sendCustomerAppDownloadText };
